// extracted by mini-css-extract-plugin
module.exports = {"btn":"x_p q_ry q_rd h_fq h_fF h_ft h_hg","full":"x_sS h_dq h_dB"};